import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import SearchCanvasUsers from './SearchCanvasUsers';
import {BASENAME} from "../../constants";
import {ROLES, withRoles} from "../Permissions";
import ConfirmDialog from "../parts/ConfirmDialog";


import Loader from 'react-loader';

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: '10px',
        overflowX: 'auto',
    },
    table: {
        // minWidth: 700,
    }
});

class CoordinatorNew extends Component {
    constructor(props) {
        super(props);
        this.state = {
            canvasUsers: [],
            addedUser: {},
            open: false,
            loaded: true
        };
    }

    onStart = () => {
        this.setState({loaded: false});
    };

    onSuccess = ({open, addedUser}) => {
        // open confirm dialog
        this.setState({
            open,
            addedUser,
            loaded: true
        });
    };

    onError = (err) => {
        this.setState({
            loaded: true
        });
        // handle error here
        console.log(err);
    };

    addCanvasUser = (user) => {
        const canvasUsers = [...this.state.canvasUsers, user];
        this.setState({canvasUsers});
    };

    onUserSelection = async (selectedCanvasUser) => {
        this.onStart();
        try {
            // add user to DB with default coordinator role
            const body = {
                unid: selectedCanvasUser.unid,
                display_name: selectedCanvasUser.display_name,
                departments: selectedCanvasUser.departments,
                roles: [ROLES.COORDINATOR]
            };

            const res = await fetch(BASENAME + '/api/users', {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(body)
            });

            const addedUser = await res.json();

            this.onSuccess({
                open: true,
                addedUser: addedUser
            });
        } catch(err) {
            this.onError(err);
        }
    };

    filterCanvasUsers = (users) => {
        return users;
    };

    resetCanvasUsers = () => {
        this.setState({canvasUsers: []});
    };

    handleClose = () => {
        this.setState({open: false})
    };

    render() {
        return (
            <div>
                <h2>New Coordinator page</h2>
                <SearchCanvasUsers
                    addType = 'newUser'
                    onUserSelection={this.onUserSelection}
                    filterCanvasUsers={this.filterCanvasUsers}
                    canvasUsers={this.state.canvasUsers}
                    addCanvasUser={this.addCanvasUser}
                    resetCanvasUsers={this.resetCanvasUsers}
                >
                    <Fab size="small" color="secondary" aria-label="Add"
                         className={this.props.classes.margin}>
                        <AddIcon/>
                    </Fab>
                </SearchCanvasUsers>
                <Loader loaded={this.state.loaded}/>
                <ConfirmDialog
                    title={"Coordinator Successfully Added!"}
                    handleClose={this.handleClose}
                    open={this.state.open}
                >
                    Name: {this.state.addedUser.display_name && this.state.addedUser.display_name}<br/>
                    uNID: {this.state.addedUser.unid && this.state.addedUser.unid}<br/>
                    Existing roles: {this.state.addedUser.roles && this.state.addedUser.roles.join(", ")}<br/>
                    Departments: {this.state.addedUser.departments && this.state.addedUser.departments.join(", ")}
                </ConfirmDialog>
            </div>
        );
    }
}

export default withStyles(styles)(withStyles(styles)(withRoles([ROLES.COORDINATOR, ROLES.ADMIN])(CoordinatorNew)));
